const CloseIconBig = ({
    width = "14",
    height = "14",
    viewBox = "0 0 14 14",
    fill = "none",
    xmlns = "http://www.w3.org/2000/svg",
    pathFill = "#727580",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        xmlns={xmlns}
        {...props}
    >
        <path
            d="M6.99272 8.78256L2.14453 13.6311C1.88866 13.8867 1.59777 14.0095 1.27187 13.9994C0.945977 13.9893 0.655092 13.8565 0.399218 13.6008C0.143546 13.3449 0.0157091 13.049 0.0157091 12.713C0.0157091 12.377 0.143546 12.0811 0.399218 11.8252L5.21744 7.00728L0.368949 2.15909C0.113277 1.90322 -0.0095151 1.60729 0.000574581 1.2713C0.0106643 0.935313 0.143546 0.639382 0.399218 0.383508C0.655092 0.127836 0.951022 0 1.28701 0C1.62299 0 1.91892 0.127836 2.1748 0.383508L6.99272 5.232L11.8409 0.383508C12.0968 0.127836 12.3927 0 12.7287 0C13.0647 0 13.3606 0.127836 13.6165 0.383508C13.8722 0.639382 14 0.935313 14 1.2713C14 1.60729 13.8722 1.90322 13.6165 2.15909L8.768 7.00728L13.6165 11.8555C13.8722 12.1113 14 12.4022 14 12.7281C14 13.054 13.8722 13.3449 13.6165 13.6008C13.3606 13.8565 13.0647 13.9843 12.7287 13.9843C12.3927 13.9843 12.0968 13.8565 11.8409 13.6008L6.99272 8.78256Z"
            fill={pathFill}
        />
    </svg>
);

export {CloseIconBig};
